import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYandexComponent } from './simple-icons-yandex.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYandexComponent ],
    exports:      [ SimpleIconsYandexComponent ],
    bootstrap:    []
})
export class SimpleIconsYandexModule {}
